<template>
	<div class="MAM_queryList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">

				<el-form-item>
					<el-date-picker type="date" placeholder="提现开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
						-
					<el-date-picker type="date" placeholder="提现结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.team_status" clearable placeholder="提现状态">
						<el-option label="出款成功" value="2"></el-option>
						<el-option label="审核中" value="1"></el-option>
						<el-option label="待出款" value="4"></el-option>
						<el-option label="出款失败" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px">
				<span>提现总金额：{{stockTable.all_money}} 元</span>
			</div>
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
			
				<el-table-column header-align="center" align="center" prop="create_time" label="提现时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="money" label="提现金额(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="fee_money" label="提现手续费(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="service_fee" label="提现服务费(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="true_money" label="提现到账金额(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="remain_money" label="剩余可提现金额(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="team_status_text" label="状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 4" style="color:#F56C6C">
							{{scope.row.team_status_text}}
						</span>
						<span v-else>{{scope.row.team_status_text}}</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="reject_reason" label="审核原因"></el-table-column>
				<el-table-column header-align="center" align="center" prop="repay_time" label="出款时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="bank_code" label="到账银行卡"></el-table-column>
				<el-table-column header-align="center" align="center" prop="bank_name" label="银行卡总行"></el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
		
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "tixianrecord",
		data() {
			return {
				queryForm: {
					user_id: this.$route.query.user_id,
					is_list:2,
					team_status:'',
					start_time:'',
					end_time:'',
				},
				stockTable: { //列表
					list: [],
					all_money:0,
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,
				downLoading:false
			}
		},
		mounted() {
			this.loading = true;
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				user_id: this.$route.query.user_id,
				is_list:2
			})
		},
		components: {
			paginations,
		},
		methods: {
			handleDownLoad(params) { //导出
				let reqData = {
					type: 12,
					value: JSON.stringify(params)
				};
			
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				queryForm.user_id = this.$route.query.user_id;
				queryForm.is_list = 2;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("userteamleader/getUserTeamWithdrawList", params, res => {
					let data = res.data.data;
					this.page.total = data.list.total; //总数
					this.stockTable.list = data.list.data;
					this.stockTable.all_money = data.with_draw_money;
					// //渲染结束后取消加载
					this.loading = false;
					
					
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>